export enum ModalType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Confirm = 'confirm',
}

export enum ModalSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Full = 'full',
}
